import { useId } from 'react'
import { useTranslation } from 'react-i18next'
import { Button } from '../Button/Button'
import { Card } from '../Card/Card'
import { ImagePlaceholder } from '../ImagePlaceholder/ImagePlaceholder'
import { cx } from '../utils/cx'
import type { ExtraCardProps } from './types'
import './ExtraCard.css'

/** Tarjeta de extra (DESIGN.md §4): foto 16:10, nombre h3, precio tabular, una línea, botón secundario. Sin urgencia. */
export function ExtraCard({ name, price, description, image, imageLabel, onAdd, added, disabled, addLabel, addedLabel, headingLevel = 3, className }: ExtraCardProps) {
  const { t } = useTranslation()
  const nameId = useId()
  const Heading = headingLevel === 2 ? 'h2' : 'h3'
  const media = image ?? <ImagePlaceholder label={imageLabel ?? t('v2.ds.extraCard.fotoExtra')} />
  return (
    <Card image={media} imageAlt="" className={cx('hp-extra', added && 'hp-extra--added', className)}>
      <div className="hp-extra__body">
        <div className="hp-extra__head">
          <Heading id={nameId} className="hp-extra__name">
            {name}
          </Heading>
          <span className="hp-extra__price tnum">{price}</span>
        </div>
        {description && <p className="hp-extra__desc">{description}</p>}
        <Button variant="secondary" icon={added ? 'check' : 'plus'} onClick={onAdd} className="hp-extra__button" aria-pressed={added ?? false} aria-describedby={nameId} disabled={disabled ?? false}>
          {added ? (addedLabel ?? t('v2.ds.extraCard.anadidoQuitar')) : (addLabel ?? t('v2.ds.extraCard.anadir'))}
        </Button>
      </div>
    </Card>
  )
}
